import { ColumnsType } from "antd/lib/table";
import { Table } from "antd";
import { usePublicDocumentInfo } from "../../../document/hooks/published-documents/use-public-documents-info";
import Chart from "react-google-charts";

type DataType = {
  title: string;
  count: number;
  percent: number;
};

const options = {
  title: "",
  is3D: true,
  colors: ["#5a99d3", "#e97c30"],
  chartArea: { left: "5%", top: "5%", width: "100%", height: "100%" },
};

export const DocumentStatisticByUserChart = () => {
  const { countReadUser, totalUser, isFetched } = usePublicDocumentInfo();

  const data = [
    { title: "Số người được triển khai", count: totalUser, percent: 100 },
    {
      title: "Số người đã đọc tài liệu/văn bản",
      count: countReadUser,
      percent: (countReadUser / totalUser) * 100,
    },
    {
      title: "Số người chưa đọc tài liệu/văn bản",
      count: totalUser - countReadUser,
      percent: ((totalUser - countReadUser) / totalUser) * 100,
    },
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: "",
      key: "title",
      dataIndex: "title",
    },
    {
      title: "Số lượng",
      key: "count",
      dataIndex: "count",
      align: "center" as const,
    },
    {
      title: "Phần trăm",
      key: "percent",
      dataIndex: "percent",
      align: "center" as const,
      render: (percent: number) => `${percent?.toFixed(2)}%`,
    },
  ];

  const dataName = [
    ["", ""],
    ["Số lượng người đã đọc", data ? countReadUser : 0],
    ["Số lượng người chưa đọc", data ? totalUser - countReadUser : 100],
  ];

  return isFetched ? (
    <div className="d-flex column">
      <Table columns={columns} dataSource={data} />
      <Chart chartType="PieChart" data={dataName} width={"100%"} height={"200px"} options={options} />
    </div>
  ) : (
    <></>
  );
};
